
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useRealtimeUpdates(fetchUsers: () => Promise<void>) {
  useEffect(() => {
    console.log('Setting up realtime subscription for user_profiles');
    
    // Set up real-time subscription for user_profiles table updates
    const channel = supabase
      .channel('user-profiles-changes')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'user_profiles' }, 
        (payload) => {
          console.log('Real-time update received:', payload);
          // Force refresh when any change occurs
          fetchUsers();
        }
      )
      .subscribe();

    // Cleanup subscription on unmount
    return () => {
      console.log('Cleaning up realtime subscription');
      supabase.removeChannel(channel);
    };
  }, [fetchUsers]);
}
